<template>
  <b-container fluid class="my-5">
    <b-row class="justify-content-center">
      <b-col cols="8">
				<b-container fluid>
					<b-row>
						<b-col sm="12" md="2">
							<img :src="imageSrc" alt="Logo" />
						</b-col>
						<b-col md="10" lg="10">
							<div class="title__subtitle" v-html="sanitizedContent(subtitle)"></div>
							<br />
							<div class="mb-3 accordion-container" v-for="(qa, i) in qaContent" :key="qa.title">
								<div role="tab">
									<div role="button" class="accordion__title" v-b-toggle="`accordion-${i}`">
										<p>{{ qa.title }}</p>
										<b-icon-chevron-down class="accordion__icon-down" font-scale="1.5" style="color: #D80B8C;" />
										<b-icon-chevron-up class="accordion__icon-up" font-scale="1.5" style="color: #D80B8C;" />
									</div>
								</div>
								<b-collapse :id="`accordion-${i}`" :accordion="accordionGroup" v-model="visibles[i]">
									<div class="accordion__content" v-html="sanitizedContent(qa.content)"></div>
								</b-collapse>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    title: String,
    subtitle: String,
    image: Object,
    qaContent: Array,
    email: Object,
    phone: Object,
    expandAllLabel: String,
    collapseAllLabel: String
  },
  data() {
    return {
      accordionGroup: 'accordion',
      visibles: Array(this.qaContent.length).fill(false)
    }
  },
  computed: {
    accordions() {
      return this.qaContent.map((_, i) => `accordion-${i}`)
    },
    imageSrc() {
      return `/strapi/${this.image.data.attributes.url}`
    },
  },
  methods: {
    expandAll() {
      this.accordionGroup = this.accordionGroup === undefined ? 'accordion' : undefined
      this.visibles = Array(this.qaContent.length).fill(!this.accordionGroup)
    },
    sanitizedContent(content) {
      return DOMPurify.sanitize(marked(content))
    }
  }
}
</script>

<style scoped src="@/assets/css/faq.css"/>
